import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { border, spacing } from '@metro-ui/tokens/js';
import { Link } from '../../Link';
import { IconButton } from '../../Button';
var marginMap = {
    small: "calc(" + spacing['x-small'] + " - " + border.width.medium + ") calc(" + spacing.small + " - " + border.width.medium + ")",
    medium: "calc(" + spacing.small + " - " + border.width.medium + ")",
    large: "calc(1.25rem - " + border.width.medium + ") calc(" + spacing.small + " - " + border.width.medium + ")",
};
export var CtaLink = styled(Link, {
    shouldForwardProp: function (prop) { return prop !== 'alertSize'; },
})(function (_a) {
    var alertSize = _a.alertSize;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-self: flex-start;\n    color: inherit;\n    flex-shrink: 0;\n    margin: ", ";\n    line-height: 1rem;\n\n    &:hover,\n    &:focus,\n    &:active {\n      color: inherit;\n    }\n  "], ["\n    align-self: flex-start;\n    color: inherit;\n    flex-shrink: 0;\n    margin: ", ";\n    line-height: 1rem;\n\n    &:hover,\n    &:focus,\n    &:active {\n      color: inherit;\n    }\n  "])), marginMap[alertSize]);
});
export var CtaButton = CtaLink.withComponent(IconButton);
var templateObject_1;
//# sourceMappingURL=Cta.js.map